<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21.846" height="18.19" viewBox="0 0 21.846 18.19">
    <g transform="translate(-383.077 -391.405)">
      <path
        d="M383.577,409.6a.509.509,0,0,1-.2-.041.5.5,0,0,1-.3-.459v-16.43a.5.5,0,0,1,.5-.5h10.361a.5.5,0,0,1,.5.5v2.845a.5.5,0,0,1-.5.5h-9.7a.5.5,0,0,1-.161-.027v6.211h20.346a.5.5,0,0,1,.5.5v6.4a.5.5,0,0,1-.866.341l-3.325-3.575-2.891,2.782a.5.5,0,0,1-.677.014l-3.2-2.819-2.716,2.793a.5.5,0,0,1-.686.03l-3.032-2.618-3.609,3.416A.5.5,0,0,1,383.577,409.6Zm.5-6.4v4.739l3.093-2.928a.5.5,0,0,1,.671-.016l3.018,2.606,2.721-2.8a.5.5,0,0,1,.689-.027l3.21,2.83,2.926-2.815a.5.5,0,0,1,.713.02l2.8,3.015v-4.628Zm0-10.029v1.871a.5.5,0,0,1,.161-.026h9.2v-1.845Z"
        fill="#777"
      />
      <path
        d="M388.777,402.733c-.842-3.65-4.758-4.11-4.8-4.115l.106-.994c.047.005,4.666.549,5.666,4.885Z"
        fill="#777"
      />
      <rect
        width="1"
        height="5.572"
        transform="translate(389.584 391.405)"
        fill="#777"
      />
      <rect
        width="1"
        height="2.627"
        transform="translate(399.905 399.914)"
        fill="#777"
      />
    </g>
  </svg>
</template>
